import { TFunction } from "i18next";

import { notifications } from "@mantine/notifications";

import { normalizeError, SimpleResult } from "@prostocheck/shared";

/**
 * The one place a failed ДПС read becomes visible: a toast for the user, the
 * full `SimpleResult` in the console for debugging. Called from a hook after
 * an imperative fetch fails, never from a component.
 */
export const notifyError = <T>({
  result,
  t,
}: {
  result: SimpleResult<T>;
  t: TFunction;
}): void => {
  console.error(result);

  notifications.show({
    color: "red",
    message: normalizeError(result, t),
  });
};
